// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibKlangScriptIgnitorClassicSlotsChunk0() {

    // @TypeExtensions(KlangScriptIgnitorVibratoSlots::class) on KlangScriptIgnitorVibratoSlots
    registerType<KlangScriptIgnitorVibratoSlots> {
        registerProperty("rate") { KlangScriptIgnitorVibratoSlots.rate }
        registerProperty("semitones") { KlangScriptIgnitorVibratoSlots.semitones }
        registerProperty("rangeFrom") { KlangScriptIgnitorVibratoSlots.rangeFrom }
        registerProperty("rangeTo") { KlangScriptIgnitorVibratoSlots.rangeTo }
        registerProperty("phase") { KlangScriptIgnitorVibratoSlots.phase }
    }

    // @TypeExtensions(KlangScriptIgnitorFmSlots::class) on KlangScriptIgnitorFmSlots
    registerType<KlangScriptIgnitorFmSlots> {
        registerProperty("ratio") { KlangScriptIgnitorFmSlots.ratio }
        registerProperty("depth") { KlangScriptIgnitorFmSlots.depth }
        registerProperty("attack") { KlangScriptIgnitorFmSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorFmSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorFmSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorFmSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorPenvSlots::class) on KlangScriptIgnitorPenvSlots
    registerType<KlangScriptIgnitorPenvSlots> {
        registerProperty("semitones") { KlangScriptIgnitorPenvSlots.semitones }
        registerProperty("attack") { KlangScriptIgnitorPenvSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorPenvSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorPenvSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorPenvSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorPenvCurvesSlots::class) on KlangScriptIgnitorPenvCurvesSlots
    registerType<KlangScriptIgnitorPenvCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorPenvCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorPenvCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorPenvCurvesSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorCrushSlots::class) on KlangScriptIgnitorCrushSlots
    registerType<KlangScriptIgnitorCrushSlots> {
        registerProperty("bits") { KlangScriptIgnitorCrushSlots.bits }
    }

    // @TypeExtensions(KlangScriptIgnitorCoarseSlots::class) on KlangScriptIgnitorCoarseSlots
    registerType<KlangScriptIgnitorCoarseSlots> {
        registerProperty("factor") { KlangScriptIgnitorCoarseSlots.factor }
    }

    // @TypeExtensions(KlangScriptIgnitorDistortSlots::class) on KlangScriptIgnitorDistortSlots
    registerType<KlangScriptIgnitorDistortSlots> {
        registerProperty("amount") { KlangScriptIgnitorDistortSlots.amount }
        registerProperty("shape") { KlangScriptIgnitorDistortSlots.shape }
    }

    // @TypeExtensions(KlangScriptIgnitorHpfSlots::class) on KlangScriptIgnitorHpfSlots
    registerType<KlangScriptIgnitorHpfSlots> {
        registerProperty("freq") { KlangScriptIgnitorHpfSlots.freq }
        registerProperty("q") { KlangScriptIgnitorHpfSlots.q }
        registerProperty("passes") { KlangScriptIgnitorHpfSlots.passes }
        registerProperty("env") { KlangScriptIgnitorHpfSlots.env }
        registerProperty("attack") { KlangScriptIgnitorHpfSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorHpfSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorHpfSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorHpfSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorBpfSlots::class) on KlangScriptIgnitorBpfSlots
    registerType<KlangScriptIgnitorBpfSlots> {
        registerProperty("freq") { KlangScriptIgnitorBpfSlots.freq }
        registerProperty("q") { KlangScriptIgnitorBpfSlots.q }
        registerProperty("env") { KlangScriptIgnitorBpfSlots.env }
        registerProperty("attack") { KlangScriptIgnitorBpfSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorBpfSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorBpfSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorBpfSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorNotchSlots::class) on KlangScriptIgnitorNotchSlots
    registerType<KlangScriptIgnitorNotchSlots> {
        registerProperty("freq") { KlangScriptIgnitorNotchSlots.freq }
        registerProperty("q") { KlangScriptIgnitorNotchSlots.q }
        registerProperty("env") { KlangScriptIgnitorNotchSlots.env }
        registerProperty("attack") { KlangScriptIgnitorNotchSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorNotchSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorNotchSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorNotchSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorLpfSlots::class) on KlangScriptIgnitorLpfSlots
    registerType<KlangScriptIgnitorLpfSlots> {
        registerProperty("freq") { KlangScriptIgnitorLpfSlots.freq }
        registerProperty("q") { KlangScriptIgnitorLpfSlots.q }
        registerProperty("passes") { KlangScriptIgnitorLpfSlots.passes }
        registerProperty("env") { KlangScriptIgnitorLpfSlots.env }
        registerProperty("attack") { KlangScriptIgnitorLpfSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorLpfSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorLpfSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorLpfSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorTremoloSlots::class) on KlangScriptIgnitorTremoloSlots
    registerType<KlangScriptIgnitorTremoloSlots> {
        registerProperty("depth") { KlangScriptIgnitorTremoloSlots.depth }
        registerProperty("rate") { KlangScriptIgnitorTremoloSlots.rate }
        registerProperty("shape") { KlangScriptIgnitorTremoloSlots.shape }
    }

    // @TypeExtensions(KlangScriptIgnitorAdsrSlots::class) on KlangScriptIgnitorAdsrSlots
    registerType<KlangScriptIgnitorAdsrSlots> {
        registerProperty("attack") { KlangScriptIgnitorAdsrSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorAdsrSlots.decay }
        registerProperty("sustain") { KlangScriptIgnitorAdsrSlots.sustain }
        registerProperty("release") { KlangScriptIgnitorAdsrSlots.release }
        registerProperty("on") { KlangScriptIgnitorAdsrSlots.on }
    }

    // @TypeExtensions(KlangScriptIgnitorAdsrCurvesSlots::class) on KlangScriptIgnitorAdsrCurvesSlots
    registerType<KlangScriptIgnitorAdsrCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorAdsrCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorAdsrCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorAdsrCurvesSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorHpfCurvesSlots::class) on KlangScriptIgnitorHpfCurvesSlots
    registerType<KlangScriptIgnitorHpfCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorHpfCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorHpfCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorHpfCurvesSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorBpfCurvesSlots::class) on KlangScriptIgnitorBpfCurvesSlots
    registerType<KlangScriptIgnitorBpfCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorBpfCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorBpfCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorBpfCurvesSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorNotchCurvesSlots::class) on KlangScriptIgnitorNotchCurvesSlots
    registerType<KlangScriptIgnitorNotchCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorNotchCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorNotchCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorNotchCurvesSlots.release }
    }

    // @TypeExtensions(KlangScriptIgnitorLpfCurvesSlots::class) on KlangScriptIgnitorLpfCurvesSlots
    registerType<KlangScriptIgnitorLpfCurvesSlots> {
        registerProperty("attack") { KlangScriptIgnitorLpfCurvesSlots.attack }
        registerProperty("decay") { KlangScriptIgnitorLpfCurvesSlots.decay }
        registerProperty("release") { KlangScriptIgnitorLpfCurvesSlots.release }
    }
}

